import { render, staticRenderFns } from "./LegList.vue?vue&type=template&id=7b2f7d80&scoped=true&"
import script from "./LegList.vue?vue&type=script&lang=js&"
export * from "./LegList.vue?vue&type=script&lang=js&"
import style0 from "./LegList.vue?vue&type=style&index=0&id=7b2f7d80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2f7d80",
  null
  
)

export default component.exports